import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
	useTheme,
} from "@mui/material";
import moment from "moment";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import type { IAuditTrail } from "./AuditTrail";
import dayjs from "dayjs";
import CommonPdfAndImageView from "src/common/CommonPdfAndImageView";
type IProps = {
	isLoading: Boolean;
	data: IAuditTrail[];
	paginationSkip: number | string;
};
const AuditTrailTableRow = ({ isLoading, data, paginationSkip }: IProps) => {
	const theme = useTheme();
	return (
		<>
			<TableContainer>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell>SL.</TableCell>
							<TableCell>Admin Name</TableCell>
							<TableCell>Details</TableCell>
							<TableCell>Date</TableCell>
						</TableRow>
					</TableHead>

					{isLoading ? (
						<TableLoader />
					) : data?.length ? (
						<TableBody>
							{data?.map((allAdmin, index) => {
								return (
									<TableRow hover key={allAdmin.fair_id}>
										<TableCell>
											<Typography
												variant='body1'
												color='text.primary'
												gutterBottom
												noWrap
											>
												{index +
													1 +
													Number(paginationSkip)}
											</Typography>
										</TableCell>
										<TableCell
											sx={{
												display: "flex",
												alignItems: "center",
												columnGap: 1,
											}}
										>
											<CommonPdfAndImageView
												file={
													allAdmin.audit_trail_admin_photo
												}
												showAvater
											/>
											<Typography
												variant='body1'
												color='text.primary'
												gutterBottom
												noWrap
											>
												{
													allAdmin.audit_trail_admin_name
												}
											</Typography>
										</TableCell>

										<TableCell>
											<Typography
												sx={{ maxWidth: "400px" }}
											>
												{allAdmin.audit_trail_details}
											</Typography>
										</TableCell>

										<TableCell>
											<Typography
												variant='body1'
												color='text.primary'
												gutterBottom
												noWrap
											>
												{dayjs(
													allAdmin.audit_trail_created_at
												).format("DD-MMM-YYYY HH:mm A")}
											</Typography>
										</TableCell>
									</TableRow>
								);
							})}
						</TableBody>
					) : (
						<TableNotFound />
					)}
				</Table>
			</TableContainer>
		</>
	);
};

export default AuditTrailTableRow;
